import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {Atividade} from "./atividade";
import {AtividadeNacional} from "./atividade.nacional";
import {Municipio} from "./municipio";

@JacksonType("VinculoAtividadeNacional")
@JsonIdentityInfo()
export class VinculoAtividadeNacional extends SonnerBaseEntity {

  id: number;

  @JacksonType("AtividadeNacional")
  atividadeNacional: AtividadeNacional;

  @JacksonType("Atividade")
  atividade: Atividade;

  @JacksonType("Municipio")
  municipio: Municipio;

  //transients
  sugestao: boolean;

}
